import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/auth.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'retterseismo';

  constructor(private authService: AuthService){}

  ngOnInit(): void {
    this.authService.autoLoginUser(); 
  }

  ngAfterViewInit(){
    setTimeout(() => {
      document.body.classList.remove('hidden-until-init');  
    }, 500);
  }
  
}
